import React, { FC, ReactNode, useMemo } from "react";
import moment from "moment";

export enum DateFormat {
  LongMonthDayComaYear = "MMMM D, YYYY",
  ShortMonthDay = "MMM D",
  USStandardWithTime = "MM/DD/YYYY h:mm A",
}

export interface DateFormattedProps {
  date?: Date | string;
  format?: DateFormat;
  fallback?: ReactNode;
}

export const DateFormatted: FC<DateFormattedProps> = ({ date, format, fallback }) => {
  const dateFormatted = useMemo(() => {
    return date ? moment(date).format(format ?? DateFormat.LongMonthDayComaYear) : fallback;
  }, [date, format, fallback]);

  return <>{dateFormatted}</>;
};
